<template>
  <authorization permissionKey="configuration_facilitator_bio" can="read">
    <v-container fluid>
      <v-row>
        <v-col class="text-h3 gray--text">
          Facilitadores da Biomicroscopia
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-tabs v-model="tab" background-color="transparent" color="secondary" show-arrows>
            <v-tab v-for="(value, key) in facilitatorTypes" :key="key">
              {{ value }}
            </v-tab>
          </v-tabs>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-tabs-items v-model="tab">
            <v-tab-item v-for="(value, key) in facilitatorTypes" :key="key">
              <ConfigBioList
                :facilitators="biomicroscopyFacilitators"
                :facilitatorType="key"
                :refreshList="refreshList"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-container>
  </authorization>
</template>

<script>
  import ConfigBioList from "@/components/config/biomicroscopy/index.vue";

  export default {
    name: "BioFacilitators",
    components: {
      ConfigBioList,
    },
    data() {
      return {
        tab: null,
        facilitatorTypes: {
          site: "Local",
          external_exam: "Exame Ocular Externo",
          eyelids_and_eyelashes: "Pálpebras e Cílios",
          tears_duct: "Vias Lacrimais",
          tarsal: "Tarso",
          conjunctiva: "Conjuntiva",
          cornea: "Córnea",
          iris: "Íris",
          anterior_chamber: "Câmara Anterior",
          len: "Lente",
          intensity: "Intensidade",
        },
      };
    },
    apollo: {
      biomicroscopyFacilitators: {
        query: require("@/graphql/biomicroscopy/biomicroscopy_facilitators.gql"),
      },
    },
    methods: {
      refreshList() {
        this.$apollo.queries.biomicroscopyFacilitators.refetch();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
